import { ePageBaseStatus } from "../../../models/ePageBaseStatus"
import { IDotDanhGiaLopActionType } from "../../action-types/danh-gia/IDotDanhGiaLopActionType"
import { IDotDanhGiaLopReducer } from "../../page-state-model/danh-gia/IDotDanhGiaLopReducer"

const iniState: IDotDanhGiaLopReducer = {
    dotDanhGiaIdSelected: 0,
}
export const dotDanhGiaLopReducer = (state: IDotDanhGiaLopReducer = iniState, action: IDotDanhGiaLopActionType): IDotDanhGiaLopReducer => {
    const dotDanhGiaId = action?.payload?.dotDanhGiaId ?? 0
    switch (action.type) {
        case "DOT_DANH_GIA_LOP_CHANGE_DOT_DANH_GIA_SELECTED_ID":
            return {
                ...state,
                dotDanhGiaIdSelected: action.payload.dotDanhGiaId
            }
        case "DOT_DANH_GIA_LOP_LOAD_START":
            return {
                ...state,
                [dotDanhGiaId]: {
                    ...state[dotDanhGiaId],
                    status: ePageBaseStatus.is_loading,
                    selectedIds:[]
                }
            }
        case "DOT_DANH_GIA_LOP_LOAD_SUCCESS":
            return {
                ...state,
                [dotDanhGiaId]: {
                    ...state[dotDanhGiaId],
                    status: ePageBaseStatus.is_completed,
                    dotDanhGiaLops: action.payload.data
                }
            }
        case "DOT_DANH_GIA_LOP_LOAD_ERROR":
            return {
                ...state,
                [dotDanhGiaId]: {
                    ...state[dotDanhGiaId],
                    status: ePageBaseStatus.is_completed
                }
            }
        case "DOT_DANH_GIA_LOP_SHOW_ADD_LOP_MODAL":
            return {
                ...state,
                [dotDanhGiaId]: {
                    ...state[dotDanhGiaId],
                    isShowEditModal: action.payload.data
                }
            }
        case "DOT_DANH_GIA_LOP_ADD_LOP_START":
            return {
                ...state,
                [dotDanhGiaId]: {
                    ...state[dotDanhGiaId],
                    status: ePageBaseStatus.is_saving
                }
            }
        case "DOT_DANH_GIA_LOP_ADD_LOP_SUCCESS":
            return {
                ...state,
                [dotDanhGiaId]: {
                    ...state[dotDanhGiaId],
                    isShowEditModal: false,
                    status: ePageBaseStatus.is_need_reload
                }
            }
        case "DOT_DANH_GIA_LOP_ADD_LOP_ERROR":
            return {
                ...state,
                [dotDanhGiaId]: {
                    ...state[dotDanhGiaId],
                    status: ePageBaseStatus.is_completed
                }
            }
        case "DOT_DANH_GIA_LOP_UPDATE_LOP_START":
            return {
                ...state,
                [dotDanhGiaId]: {
                    ...state[dotDanhGiaId],
                    status: ePageBaseStatus.is_saving
                }
            }
        case "DOT_DANH_GIA_LOP_UPDATE_LOP_SUCCESS":
            return {
                ...state,
                [dotDanhGiaId]: {
                    ...state[dotDanhGiaId],
                    status: ePageBaseStatus.is_need_reload
                }
            }
        case "DOT_DANH_GIA_LOP_UPDATE_LOP_ERROR":
            return {
                ...state,
                [dotDanhGiaId]: {
                    ...state[dotDanhGiaId],
                    status: ePageBaseStatus.is_completed
                }
            }
        case "DOT_DANH_GIA_LOP_DELETE_LOP_START":
            return {
                ...state,
                [dotDanhGiaId]: {
                    ...state[dotDanhGiaId],
                    status: ePageBaseStatus.is_deleting
                }
            }
        case "DOT_DANH_GIA_LOP_DELETE_LOP_SUCCESS":
            return {
                ...state,
                [dotDanhGiaId]: {
                    ...state[dotDanhGiaId],
                    status: ePageBaseStatus.is_need_reload
                }
            }
        case "DOT_DANH_GIA_LOP_DELETE_LOP_ERROR":
            return {
                ...state,
                [dotDanhGiaId]: {
                    ...state[dotDanhGiaId],
                    status: ePageBaseStatus.is_completed
                }
            }
        case "DOT_DANH_GIA_LOP_CHANGE_SELECTED_IDS":
            return {
                ...state,
                [dotDanhGiaId]: {
                    ...state[dotDanhGiaId],
                    selectedIds: action.payload.data
                }
            }
        default:
            return state;
    }
}